import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from '@/lib/auth';
import { GiftLoader } from '@/components/GiftLoader';

/**
 * Wrap protected pages. While we're rehydrating, render a faint placeholder
 * so we don't flash the unauthed state. Once known, either render children
 * or kick the browser to AuthKit.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { session, loading, signIn } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!session) {
      signIn(location.pathname + location.search);
    }
  }, [loading, session, signIn, location]);

  if (loading || !session) {
    return (
      <section className="flex-1 flex items-center justify-center px-6 py-16">
        <GiftLoader caption={loading ? 'One moment…' : 'Taking you to sign in…'} />
      </section>
    );
  }

  return <>{children}</>;
}
